import { Box } from "@mui/material";
import { Tabs } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';

interface Tab2Props {
    form?: any;
    dataFindQard?: any[];
    dataFindSalam?: any[];
    dataFindMourabaha?: any[];
    dataFindIjara?: any[];
}

const baseColumns = (codeField: string, codeTitle: string): ColumnsType<any> => [
    {
        title: 'N° Financement',
        dataIndex: 'NumeroFinancement',
        ellipsis: true,
        width: 160,
    },
    {
        title: codeTitle,
        dataIndex: codeField,
        ellipsis: true,
        width: 130,
    },
    {
        title: 'Produit',
        dataIndex: 'NomProduit',
        ellipsis: true,
        width: 150,
    },
    {
        title: 'Gestionnaire',
        dataIndex: 'NomGestionnaire',
        ellipsis: true,
        width: 150,
    },
    {
        title: 'Montant validé',
        dataIndex: 'MontantValide',
        ellipsis: true,
        width: 130,
        align: "right"
    },
    {
        title: 'Date demande',
        dataIndex: 'DateDemande',
        ellipsis: true,
        width: 110,
    },
    {
        title: 'Date validation',
        dataIndex: 'DateVal',
        ellipsis: true,
        width: 110,
    },
];

const qardColumns: ColumnsType<any> = [
    ...baseColumns('CodeQard', 'Code Qard'),
    {
        title: 'Total décaissé',
        dataIndex: 'TotalDecaisse',
        ellipsis: true,
        width: 130,
        align: "right"
    },
    {
        title: 'Reste à décaisser',
        dataIndex: 'ResteADecaisser',
        ellipsis: true,
        width: 130,
        align: "right"
    },
];

const salamColumns: ColumnsType<any> = [
    ...baseColumns('CodeSalam', 'Code Salam'),
    {
        title: 'Livraison prévue',
        dataIndex: 'DateLivraisonPrevue',
        ellipsis: true,
        width: 120,
    },
    {
        title: 'Statut livraison',
        dataIndex: 'StatutLivraison',
        ellipsis: true,
        width: 120,
    },
];

const mourabahaColumns: ColumnsType<any> = baseColumns('CodeMourabaha', 'Code Mourabaha');

const ijaraColumns: ColumnsType<any> = baseColumns('CodeIjara', 'Code Ijara');

const Tab2 = ({ form, dataFindQard, dataFindSalam, dataFindMourabaha, dataFindIjara }: Tab2Props) => {

    const items = [
        {
            key: 'qard',
            label: `Qard (${dataFindQard?.length ?? 0})`,
            children: <Table pagination={false} size='small' dataSource={dataFindQard ?? []} columns={qardColumns} style={{ width: '100%' }} scroll={{ y: 350, x: 1300 }} />,
        },
        {
            key: 'salam',
            label: `Salam (${dataFindSalam?.length ?? 0})`,
            children: <Table pagination={false} size='small' dataSource={dataFindSalam ?? []} columns={salamColumns} style={{ width: '100%' }} scroll={{ y: 350, x: 1300 }} />,
        },
        {
            key: 'mourabaha',
            label: `Mourabaha (${dataFindMourabaha?.length ?? 0})`,
            children: <Table pagination={false} size='small' dataSource={dataFindMourabaha ?? []} columns={mourabahaColumns} style={{ width: '100%' }} scroll={{ y: 350, x: 1300 }} />,
        },
        {
            key: 'ijara',
            label: `Ijara (${dataFindIjara?.length ?? 0})`,
            children: <Table pagination={false} size='small' dataSource={dataFindIjara ?? []} columns={ijaraColumns} style={{ width: '100%' }} scroll={{ y: 350, x: 1300 }} />,
        },
    ];

    return (
        <div className='tabItem'>
            <div >
                <Box display={'flex'} fontStyle="inherit" width={"85%"} position={"absolute"} >
                    <Box fontStyle="inherit" className='bordure1' sx={{ width: '100%' }}>
                        <legend>Financements </legend>
                        <Tabs size='small' type="card" items={items} />
                    </Box>
                </Box>
            </div>
        </div>
    );
};

export default Tab2;
